import { useDataValue, useDataSubmit } from 'Simple/Data.js'

export function useOnChange(props) {
  let submit = useDataSubmit({
    context: 'referrals',
    viewPath: props.viewPath,
  })

  let referral_index = useDataValue({
    context: 'referral_item',
    viewPath: props.viewPath,
    path: 'index',
  })

  return async function onChange(value) {
    await submit({
      type: 'update_selected_index',
      index: referral_index,
      selected_index: value,
    })
  }
}
